import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const travelPricingEntity: Entity = {
  model: model,
  repository: repository,
}

export default travelPricingEntity
